// extracted by mini-css-extract-plugin
module.exports = {"tickerSearch":"styles_tickerSearch__feuxh"};